export default __webpack_public_path__ + "static/media/IconNotificacoes.8f040175.svg";